/**
 * Mirrors Laravel `config/property_tiers.php` `allowed_routes` slugs for `free_inspection`
 * (e.g. `property-inspection-reports` → this app path).
 */
export const FREE_INSPECTION_ALLOWED_PATH = "/property-inspection-reports";

export function isPathAllowedForFreeInspectionTier(pathname: string): boolean {
  return (
    pathname === FREE_INSPECTION_ALLOWED_PATH ||
    pathname.startsWith(`${FREE_INSPECTION_ALLOWED_PATH}/`)
  );
}
